import { withSvgIcon } from './withSvgIcon';

export const Dashboard = withSvgIcon(
  <>
    <path
      d="M5.28555 16.6667C3.58639 15.2917 2.5 13.1894 2.5 10.8333C2.5 6.69121 5.85786 3.33334 10 3.33334C11.1974 3.33334 12.3292 3.61393 13.3333 4.11294M14.7144 16.6667C16.4136 15.2917 17.5 13.1894 17.5 10.8333C17.5 9.63598 17.2194 8.50414 16.7204 7.50001"
      stroke="currentColor"
      strokeWidth="1.66667"
    />
    <path
      d="M9.37897 11.111L8.8233 11.732L10.0654 12.8434L10.621 12.2223L9.37897 11.111ZM10.621 12.2223L17.7044 4.30566L16.4623 3.19434L9.37897 11.111L10.621 12.2223Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
